import $ from 'jquery';

export default function (params) {
	let mUrl = {
		'f': 'https://www.facebook.com/share.php?u=',
		'vk': 'https://vk.com/share.php?url=',
		't': 'https://twitter.com/intent/tweet?url='
	},
	select = '.js_sharing',
	settings = {
		name: 'shareWindow',
		params: 'width=700,height=400,left=200,top=100,location=no, directories=no,status=no,toolbar=no,menubar=no' 
	};

	/**
	 * Metod init
	 */
	function init() {
		$(select).each(function(){

			let $this = $(this);

			$this.on('click', handlerClick);

		});
	}
	/**
	 *  Metod Get Current Url
	 */
	 function getCurrentUrl() {
		 return location.href;
	 }
	/**
	 * 
	 */
	function handlerClick(ev) {
		ev.preventDefault();
		let currentSocial = ev.target.getAttribute('data-social-network');

		window.open(mUrl[currentSocial] + ev.target.href || getCurrentUrl(), settings.name, settings.params);

	}

	init();
}


// WEBPACK FOOTER //
// ./modules/sharing.js